import { noChange } from 'lit';
import { AsyncDirective } from 'lit/async-directive.js';
import { directive } from 'lit/directive.js';
import { assignInputsObject } from './assign.directive';
import { extractDeclarativeElement } from './directive-helpers';
/**
 * Assign values but include a cleanup callback which gets called when a new value gets assigned so
 * the previous value can get cleaned up. An optional equality check callback can be provided. If it
 * is provided, the clean up callback will then only be called if the equality check callback
 * resolves to false (which indicates that the previous value and the new value are not equal).
 *
 * Example use case: 3D graphics applications with classes that setup buffers and the like.
 */
export function assignWithCleanup(elementDefinition, inputsObject, cleanupCallback) {
    /**
     * The directive generics (in listenDirective) are not strong enough to maintain their values.
     * Thus, the directive call is wrapped in this function.
     */
    return assignWithCleanupDirective(elementDefinition, inputsObject, cleanupCallback);
}
class AssignWithCleanupDirectiveClass extends AsyncDirective {
    constructor(partInfo) {
        super(partInfo);
        this.hasBeenAssigned = false;
        this.element = extractDeclarativeElement(partInfo, 'assign');
    }
    disconnected() {
        if (this.lastValue != undefined && this.lastCallback != undefined) {
            this.lastCallback(this.lastValue);
        }
    }
    render(elementDefinition, inputsObject, cleanupCallback) {
        if (this.hasBeenAssigned) {
            cleanupCallback(this.lastValue);
        }
        assignInputsObject(elementDefinition, this.element, inputsObject);
        this.hasBeenAssigned = true;
        this.lastValue = inputsObject;
        this.lastCallback = cleanupCallback;
        return noChange;
    }
}
const assignWithCleanupDirective = directive(AssignWithCleanupDirectiveClass);
